import { render, staticRenderFns } from "./benefits-tiers-section.vue?vue&type=template&id=263dc01c&scoped=true"
import script from "./benefits-tiers-section.vue?vue&type=script&lang=js"
export * from "./benefits-tiers-section.vue?vue&type=script&lang=js"
import style0 from "./benefits-tiers-section.vue?vue&type=style&index=0&id=263dc01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263dc01c",
  null
  
)

export default component.exports